import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { SortingActions } from '../constants/sorting/sorting_actions';
import { SortingValues } from '../constants/sorting/sorting_values';
import { SortingDirections } from '../constants/sorting/sorting_directions';

class CatalogSortingStoreClass extends ReduceStore {
    getInitialState() {
        return {
            currentSorting: {
                sorting: SortingValues.RELEVANCE,
                direction: SortingDirections.DESC
            },
            sortingOptions: [
                {
                    sorting: SortingValues.RELEVANCE,
                    direction: SortingDirections.DESC
                }, {
                    sorting: SortingValues.SPECIAL_DEALS,
                    direction: SortingDirections.DESC
                }, {
                    sorting: SortingValues.PRICE,
                    direction: SortingDirections.ACS
                }, {
                    sorting: SortingValues.PRICE,
                    direction: SortingDirections.DESC
                }, {
                    sorting: SortingValues.BRANDS,
                    direction: SortingDirections.ACS
                }, {
                    sorting: SortingValues.BRANDS,
                    direction: SortingDirections.DESC
                }
            ]
        };
    }

    reduce(state, {source, action}) {
        const { type, payload } = action;

        if (source === ACTION_TYPES.CATALOG_SORTING_ACTION) {
            switch (type) {
                case SortingActions.SET_SORTING:
                    if (
                        state.currentSorting.sorting !== payload.sorting ||
                        state.currentSorting.direction !== payload.direction
                    ) {
                        state.currentSorting = payload;
                        this.__emitChange();
                    }
                    break;

                case SortingActions.SET_SORTING_OPTIONS:
                    state.sortingOptions = payload;
                    this.__emitChange();

                    break;
            }
        }

        return state;
    }
}

const CatalogSortingStore = new CatalogSortingStoreClass(Dispatcher);
export { CatalogSortingStore };